import React, { FC } from 'react'

import { IconBoxProps } from './IconBox.types'
import * as Styled from './styles/IconBox.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBox: FC<IconBoxProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBoxProps['size'],
  isResponsive = false,
}: IconBoxProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m7.05 15.094 16.993 8.031L41 15.094m-33.95 0L24.294 6.96'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='m32.238 10.887-17.187 8.031V25' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M24.043 23.125v17.422M7.055 15.121v15.313a4 4 0 0 0 2.289 3.617l12.984 6.14a4.014 4.014 0 0 0 3.426 0l12.957-6.14A3.993 3.993 0 0 0 41 30.437V15.121M24.293 6.96 41 15.095'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBox
